import { render, staticRenderFns } from "./VarietiesTable.vue?vue&type=template&id=e8751c64&"
import script from "./VarietiesTable.vue?vue&type=script&lang=js&"
export * from "./VarietiesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports